const recruiterSortOptionsArr = [
    {
      val: "",
      name: "Sort By"

    },
    {
      val: "id",
      name: "Date Posted"
    },
    {
      val: "company",
      name: "Company"
    },
    {
      val: "title",
      name: "Job Title"
    },
    {
      val: "applicants",
      name: "Applicants"
    }
  ]

  export {
    recruiterSortOptionsArr
  }